import Hashids from 'hashids';

class IdMaskService {
  private readonly hashids: Hashids;

  constructor() { //entityName: string
    // 1. (using direct char codes)
    const a = String.fromCharCode(90, 114, 80, 111, 114, 116, 97, 108);     
    
    // 2. "VME202" (using Base64 — 'Vk1FMjAy' decodes to 'VME202')
    const b = atob('Vk1FMjAy');                             
    
    // 3. "60312" (using Array map char codes)
    const c = [54, 48, 51, 49, 50].map(x => String.fromCharCode(x)).join(''); 

    // Join them together without dashes to get exact string: "ZrPortalVME20260312"
    // Also appended the entityName so different forms have different GUIDs!
    const salt = [a, b, c].join(''); // + '_' + entityName;

    this.hashids = new Hashids(
      salt, 
      32, 
      '0123456789abcdef'
    );
  }

  /** Integer → GUID-like string */
  encode(id: number): string {
    const hex = this.hashids.encode(id);
    return [
      hex.slice(0, 8),
      hex.slice(8, 12),
      hex.slice(12, 16),
      hex.slice(16, 20),
      hex.slice(20, 32),
    ].join('-');
  }

  /** GUID-like string → Integer, null if invalid */
  decode(guid: string): number | null {
    const hex = guid.replace(/-/g, '');
    const result = this.hashids.decode(hex);
    return result.length > 0 ? (result[0] as number) : null;
  }
}

export const idMask = new IdMaskService();